/* eslint-disable react-hooks/exhaustive-deps */
import { doctorStatus } from '../../enum/RequestEnum';
import {
  setCurrentUserId,
  getListChannels,
  listenChannels,
} from '../../firebase';
import {
  rejoinCall,
  joinCall,
  rejectPatient,
  initHubConnection,
} from '../../helpers/waitingRoomSignalR';
import TableCellFilted from '../common/componentUI/TableCellFilted';
import waitingRoomDispatcher from './action/waitingRoom';
import StreamInCallPanel from './component/StreamInCallPanel';
import ModalSummary from './component/StreamInCallPanel/ModalSummary';
import ModalVerifyID from './component/StreamInCallPanel/ModalVerifyID';
import { DOCTOR_STATUS, renderTeleQueueCol } from './constants';
import {
  CloseCircle,
  ConfirmIcon,
  ConnectingIcon,
  EndCall2Icon,
  NoDataTelecounsel,
  Teleconsult,
} from '@/assets/svg';
import { ROLE_TYPES, ROLES_NAMES_SPECIAL } from '@/constants/roles';
import { loadFromStorage } from '@/helpers/StorageHelper';
import { romeoServiceSingleton } from '@/helpers/romeoServices';
import { configure } from '@/index';
import CustomButton from '@/new-components/CustomButton';
import CustomMenu from '@/new-components/CustomMenu';
import CustomMenuActions from '@/new-components/CustomMenuActions';
import ModalConfirmation from '@/new-components/CustomModal/ModalConfirmation';
import ModalLoading from '@/new-components/CustomModal/ModalLoading';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import CustomTable from '@/new-components/CustomTable';
import CustomTooltip from '@/new-components/CustomTooltip';
import {
  TableHead,
  TableRow,
  TableCell,
  withStyles,
  Button,
  IconButton,
} from '@material-ui/core';
import { MoreVertRounded } from '@material-ui/icons';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from 'react';
import { useSelector } from 'react-redux';

const StartCallButton = withStyles((theme) => ({
  root: {
    padding: '8px 12px',
    minWidth: 93,
  },
}))(Button);

const WaitingRoom = () => {
  let waitingList = useSelector((state) => state.waitingRoom.waitingList);
  const calling = useSelector((state) => state.waitingRoom.calling);
  const callId = useSelector((state) => state.waitingRoom.callId);
  const videoChannelId = useSelector((state) => state.waitingRoom.channelId);
  const patientId = useSelector((state) => state.waitingRoom.patientId);
  const currentUser = useSelector((state) => state.auth.userInfo);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const summaryModal = useSelector((state) => state.waitingRoom.summaryModal);
  const summaryData = useSelector((state) => state.waitingRoom.summaryData);
  const isLoadingSummary = useSelector(
    (state) => state.waitingRoom.isLoadingSummary
  );

  const dataSunmmitted = useSelector(
    (state) => state.waitingRoom.dataSunmmitted
  );
  const oldData = useSelector((state) => state.waitingRoom.oldData);
  const pendingConsultationData = useSelector(
    (state) => state.waitingRoom.pendingConsultationData
  );

  // Romeo Transcription Service
  const romeoService = romeoServiceSingleton;

  const isReconnectRejoinCall = useSelector(
    (state) => state.waitingRoom.reconnectRejoinCall
  );
  const showConsConfirmVisibility = useSelector(
    (state) => state.waitingRoom.consConfirmVisibility
  );
  const showVerifyModalVisibility = useSelector(
    (state) => state.waitingRoom.verifyModalVisibility
  );
  const verifyingUserData = useSelector(
    (state) => state.waitingRoom.verifyingUserData
  );
  const waitingModalVisibility = useSelector(
    (state) => state.waitingRoom.waitingModalVisibility
  );

  const rejoinCallData = useSelector(
    (state) => state.waitingRoom.rejoinCallData
  );
  const { roleName } = useSelector((state) => state.auth.userInfo);

  const [listChannels, setListchannels] = useState([]);
  const listChannelsRef = useRef();

  const isDoctor = currentUser.roleName === ROLE_TYPES.DOCTOR;

  listChannelsRef.current = listChannels;
  const [partner, setPartner] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});

  const [showModalReject, setShowModalReject] = useState(false);
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [showModalDisconnected, setShowModalDisconnected] = useState(false);
  const [showModalLoadingSummary, setShowModalLoadingSummary] = useState(false);
  const [appointmentData, setAppointmentData] = useState();

  const [hideWaitingList, setHideWaitingList] = useState(false);

  const orderWaitingList = useMemo(() => {
    let newList = [];
    newList = [...waitingList].sort(
      (a, b) => moment(a?.JoinedTime).unix() - moment(b?.JoinedTime).unix()
    );

    return newList;
  }, [waitingList, hideWaitingList]);

  const rejoinWaitingList = useMemo(() => {
    let newList = [];

    if (
      rejoinCallData &&
      ROLES_NAMES_SPECIAL.includes(currentUser.roleName) &&
      currentUser?.approveStatus === DOCTOR_STATUS.Approved
    ) {
      const formatRejoinData = {
        ...rejoinCallData,
        FullName: rejoinCallData.PatientFullName,
        PatientRoomStatus: 'Join',
      };

      newList.unshift(formatRejoinData);
    }

    return newList;
  }, [rejoinCallData, hideWaitingList]);

  const handleToggleDisconnectedModal = useCallback(() => {
    setShowModalDisconnected(!showModalDisconnected);
  }, [showModalDisconnected]);

  const getPendingConsultation = (accessToken) => {
    fetch(`${process.env.REACT_APP_CONSULTATION_HUB_URL}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        waitingRoomDispatcher.setState('pendingConsultationData', data);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  useEffect(() => {
    if (currentUser.id) {
      initFirebase();
    }
    if (
      ROLES_NAMES_SPECIAL.includes(currentUser.roleName) &&
      currentUser.approveStatus !== doctorStatus.Approved
    )
      return;

    setTimeout(() => {
      initHubConnection(accessToken);
      getPendingConsultation(accessToken);
    }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser.id]);

  useEffect(() => {
    waitingRoomDispatcher.setState('hasTranscription', !isEmpty(oldData));
  }, [oldData]);

  // useEffect(() => {
  //   if (pendingConsultationData) {
  //     if (!isEmpty(pendingConsultationData?.callInformation?.channelId)) {
  //       handleToggleDisconnectedModal();
  //       waitingRoomDispatcher.setState('consConfirmVisibility', false);
  //     } else {
  //       if (
  //         ROLES_NAMES_SPECIAL.includes(currentUser.roleName) &&
  //         currentUser?.approveStatus === doctorStatus.Approved
  //       ) {
  //         const pendingData = pendingConsultationData?.pendingConsultation;
  //         // Check if we're already showing a modal to prevent double popup
  //         const currentState = configure.store.getState().waitingRoom;
  //         if (currentState.summaryModal || currentState.consConfirmVisibility) {
  //           return;
  //         }

  //         setAppointmentData(pendingData);

  //         if (
  //           !calling &&
  //           pendingData &&
  //           pendingData.consultStatus === 'InProgress'
  //         ) {
  //           waitingRoomDispatcher.setState('callId', pendingData.callId);

  //           if (pendingData.hasTranscription) {
  //             if (!isEmpty(pendingData.soapText)) {
  //               waitingRoomDispatcher.setState(
  //                 'dataSunmmitted',
  //                 pendingData.soapText
  //               );
  //               waitingRoomDispatcher.setState('consConfirmVisibility', true);
  //             } else {
  //               setHideWaitingList(true);
  //               waitingRoomDispatcher.setState('summaryModal', true);
  //             }
  //           } else {
  //             waitingRoomDispatcher.setState('consConfirmVisibility', true);
  //           }
  //         }
  //       }
  //     }
  //   }
  // }, [calling, pendingConsultationData]);

  useEffect(() => {
    if (pendingConsultationData) {
      if (!isEmpty(pendingConsultationData?.callInformation?.channelId)) {
        handleToggleDisconnectedModal();
        waitingRoomDispatcher.setState('consConfirmVisibility', false);
      } else {
        if (
          ROLES_NAMES_SPECIAL.includes(currentUser.roleName) &&
          currentUser?.approveStatus === doctorStatus.Approved
        ) {
          const pendingData = pendingConsultationData?.pendingConsultation;
          // Check if we're already showing a modal to prevent double popup
          const currentState = configure.store.getState().waitingRoom;
          if (currentState.summaryModal || currentState.consConfirmVisibility) {
            return;
          }

          setAppointmentData(pendingData);

          if (
            !calling &&
            pendingData &&
            pendingData.consultStatus === 'InProgress'
          ) {
            // Start for Turn off romeo transcription
            waitingRoomDispatcher.setState('consConfirmVisibility', true);
            // End for Turn off romeo transcription

            waitingRoomDispatcher.setState('callId', pendingData.callId);
          }
        }
      }
    }
  }, [calling, pendingConsultationData]);

  useEffect(() => {
    if (isLoadingSummary === undefined) return;
    if (isLoadingSummary === true) {
      setHideWaitingList(true);
      setShowModalLoadingSummary(true);
    } else {
      setShowModalLoadingSummary(false);
      const pendingData = pendingConsultationData?.pendingConsultation;
      if (
        !calling &&
        pendingData &&
        pendingData.consultStatus === 'InProgress'
      ) {
        if (!isEmpty(summaryData)) {
          if (!isEmpty(pendingData.soapText)) {
            waitingRoomDispatcher.setState(
              'dataSunmmitted',
              pendingData.soapText
            );
            waitingRoomDispatcher.setState('consConfirmVisibility', true);
          } else {
            setHideWaitingList(true);
            waitingRoomDispatcher.setState('summaryModal', true);
          }
        } else {
          waitingRoomDispatcher.setState('consConfirmVisibility', true);
        }
      }
    }
  }, [summaryData, isLoadingSummary, pendingConsultationData]);

  useEffect(() => {
    if (!accessToken || !callId) return;
    if (accessToken && callId) {
      generateSummary(accessToken, callId);
      getTranscriptionResult(accessToken, callId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, callId]);

  useEffect(() => {
    return () => {
      waitingRoomDispatcher.setState('oldData', []);
      waitingRoomDispatcher.setState('messages', {});

      waitingRoomDispatcher.setState('firstStartTranscription', false);
      waitingRoomDispatcher.setState('showTranscription', false);
    };
  }, []);

  useEffect(() => {
    if (showConsConfirmVisibility) {
      if (isEmpty(rejoinCallData)) {
        setHideWaitingList(true);
      } else {
        setHideWaitingList(false);
      }
    }
  }, [showConsConfirmVisibility, rejoinCallData]);

  const doVerify = ({ data }) => {
    waitingRoomDispatcher.getMemberAppointment(data?.UserId, () => {
      waitingRoomDispatcher.setState('verifyModalVisibility', true);
      waitingRoomDispatcher.setState('verifyingUserData', data);
    });
  };

  const doResetVerifyData = () => {
    waitingRoomDispatcher.setState('verifyModalVisibility', false);
    // waitingRoomDispatcher.setState('verifyingUserData', {});
  };

  const doCalling = async ({ data }) => {
    waitingRoomDispatcher.setState('waitingModalVisibility', true);
    waitingRoomDispatcher.setState('verifyingUserData', data);
    await joinCall(data.UserId);
  };

  const callPatient = async (data) => {
    setPartner({
      id: data.UserId,
      name: data.FullName,
      imageUrl: null,
    });

    if (data.IdentityStatus !== DOCTOR_STATUS.Approved) {
      doVerify({ data });
    } else {
      if (data.BackCorperatePlan && data.FrontCorperatePlan) {
        doVerify({ data });
      } else {
        doCalling({ data });
      }
    }
  };

  const handleToggleVerifyModal = useCallback(() => {
    waitingRoomDispatcher.setState(
      'verifyModalVisibility',
      !showVerifyModalVisibility
    );
  }, [showVerifyModalVisibility]);

  const handleToggleConsConfirmModal = useCallback(() => {
    waitingRoomDispatcher.setState(
      'consConfirmVisibility',
      !showConsConfirmVisibility
    );
  }, [showConsConfirmVisibility]);

  const handleToggleRejectModal = useCallback(() => {
    setShowModalReject(!showModalReject);
  }, [showModalReject]);

  const handleCloseVerifyModal = (shouldCleanUp) => {
    handleToggleVerifyModal();
    if (shouldCleanUp) {
      // clean up memberAppointment
      waitingRoomDispatcher.setState('memberAppointment', null);
    }
  };

  const handleToggleCancelModal = useCallback(() => {
    setShowModalCancel(!showModalCancel);
  }, [showModalCancel]);

  const initFirebase = () => {
    setCurrentUserId(currentUser.id, currentUser);
    updateListChannels();
  };

  const startTranscription = async () => {
    try {
      // if (!romeoService.isRecording) {
      //   romeoService.startRecordingDoctor();
      // }
      await romeoService.toggleRecording(accessToken);
    } catch (error) {
      console.error('Failed to start recording:', error);
    }
  };
  const generateSummary = async () => {
    try {
      await romeoService.generateSummary(accessToken, callId);
    } catch (error) {
      console.error('Failed to generate summary:', error);
    }
  };

  const getTranscriptionResult = async () => {
    try {
      await romeoService.getTranscriptionResult(accessToken, callId);
    } catch (error) {
      console.error('Failed to generate summary:', error);
    }
  };
  const stopTranscription = () => {
    romeoService.stopRecording();
  };

  const updateListChannels = async () => {
    let listChannels = await getListChannels(currentUser.id);
    listenChannels(currentUser.id, (data) => {
      if (
        [...listChannelsRef.current].find((channel) => channel.id === data.id)
      )
        setListchannels(
          [...listChannelsRef.current].map((i) => (i.id === data.id ? data : i))
        );
      else {
        setListchannels([...listChannelsRef.current, data]);
      }
    });
    setListchannels(listChannels);
  };

  const getPatientChannel = () => {
    return listChannels.find((channel) =>
      channel?.members?.includes(partner.id)
    );
  };

  const Timer = ({ time }) => {
    const [duration, setDuration] = useState(0);

    useEffect(() => {
      const serverTimeOffset = loadFromStorage('serverTimeOffset');
      const joinedTimestamp = moment.utc(time).unix() * 1000;

      const intervalId = setInterval(() => {
        const currentTimestamp = moment.utc().unix() * 1000 + serverTimeOffset;
        setDuration(() => currentTimestamp - joinedTimestamp);
      }, 1000);

      return () => clearInterval(intervalId);
    }, [time]);

    return moment.utc(duration).format('mm:ss');
  };

  const renderListActions = (selectedItem) => {
    let listActions = [];

    listActions.push({
      key: 'cancel',
      icon: CloseCircle,
      label: 'Cancel call',
      color: '#DB3D49',
      styles: { width: 18, height: 18 },
      onClick: () => {
        setAnchorEl(null);
        setShowModalCancel(true);
      },
    });

    return listActions;
  };

  const renderTableBody = useCallback(
    (row, index) => {
      return (
        <>
          <TableCell>{index + 1}</TableCell>
          <TableCell>
            <CustomTooltip content={row.FullName || '—'} />
          </TableCell>
          <TableCell>
            <CustomTooltip content={row.IdentityNumber || '—'} />
          </TableCell>
          <TableCell>{row.Age || '—'}</TableCell>
          <TableCell>{row.Gender || '—'}</TableCell>
          <TableCell>
            {row.AppointmentDate
              ? moment(row.AppointmentDate).format('LT')
              : '—'}
          </TableCell>
          <TableCell>
            {rejoinCallData ? (
              <Timer time={row.CallProblemTime} />
            ) : (
              <Timer time={row.JoinedTime} />
            )}
          </TableCell>
          {/* {!isDoctor && (
            <TableCell>
              <CustomTooltip content={row.CounsellorName || '—'} />
            </TableCell>
          )}
          <TableCell>
            <StatusComponent status={rejoinCallData ? 'Join' : 'Waiting'} />
          </TableCell> */}
          {isDoctor && (
            <TableCell>
              {ROLES_NAMES_SPECIAL.includes(roleName) && (
                <>
                  <StartCallButton
                    startIcon={<Teleconsult />}
                    color="primary"
                    variant="contained"
                    disabled={
                      rejoinCallData && row.PatientRoomStatus !== 'Join'
                    }
                    onClick={() => {
                      if (rejoinCallData) {
                        rejoinCall();
                        waitingRoomDispatcher.setState(
                          'patientId',
                          rejoinCallData.PatientId
                        );
                        waitingRoomDispatcher.setState(
                          'verifyingUserData',
                          rejoinCallData
                        );
                        setPartner({
                          id: rejoinCallData.PatientId,
                          name: `${rejoinCallData.PatientFullName}`,
                          imageUrl: null,
                        });
                      } else callPatient(row);
                    }}
                  >
                    {rejoinCallData && row.PatientRoomStatus === 'Join'
                      ? 'Rejoin'
                      : 'Start'}
                  </StartCallButton>
                  {rejoinCallData && (
                    <IconButton
                      hidden={row.PatientRoomStatus !== 'Join'}
                      onClick={(e) => {
                        setAnchorEl(e.currentTarget);
                        setSelectedItem(row);
                      }}
                    >
                      <MoreVertRounded />
                    </IconButton>
                  )}
                </>
              )}
            </TableCell>
          )}
        </>
      );
    },
    [rejoinCallData]
  );

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {renderTeleQueueCol(isDoctor).map((item) => (
          <TableCellFilted
            key={item.stateValue}
            label={item.label}
            stateValue={item.stateValue}
            style={{ minWidth: item.minWidth || 'unset' }}
            isHidden={false}
          />
        ))}
      </TableRow>
    </TableHead>
  );

  return (
    <>
      <CustomMenu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <CustomMenuActions listActions={renderListActions(selectedItem)} />
      </CustomMenu>

      <CustomPaperContainer
        header={<CustomHeader isSearch={false} title="Queue" />}
      >
        <CustomTable
          data={
            hideWaitingList
              ? []
              : isEmpty(rejoinCallData)
              ? orderWaitingList
              : rejoinWaitingList
          }
          header={TableHeader}
          renderRow={renderTableBody}
          Icon={NoDataTelecounsel}
          noDataHelperText="No clients in queue"
          noDataHelperSubText="Please come back at another time."
          totalCols={renderTeleQueueCol(isDoctor).length}
          style={{ height: 'calc(100vh - 207px)' }}
        />
      </CustomPaperContainer>

      {calling && (
        <StreamInCallPanel
          patientId={patientId}
          videoChannelId={videoChannelId}
          currentUser={currentUser}
          channelInfo={getPatientChannel()}
          partner={partner}
          updateListChannels={updateListChannels}
          verifyingUserData={verifyingUserData}
          doVerify={doVerify}
          startTranscription={startTranscription}
          stopTranscription={stopTranscription}
          setHideWaitingList={setHideWaitingList}
          debounceLoadData={() => {
            getPendingConsultation(accessToken);
          }}
        />
      )}
      {showVerifyModalVisibility && (
        <ModalVerifyID
          setShowModalReject={setShowModalReject}
          verifyingUserData={verifyingUserData}
          open={showVerifyModalVisibility}
          onClose={handleToggleVerifyModal}
          doCalling={doCalling}
          closeModal={handleCloseVerifyModal}
        />
      )}
      {showModalReject && (
        <ModalConfirmation
          open={showModalReject}
          onClick={() => {
            handleCloseVerifyModal(true);
            handleToggleRejectModal();
            rejectPatient(verifyingUserData.UserId);
          }}
          onClose={handleToggleRejectModal}
          mainContent="Reject ID"
          subContent="Are you sure you want to reject this client’s ID?"
          cancelLabel="Cancel"
          confirmLabel="Reject"
          confirmColor="red"
        />
      )}

      {showConsConfirmVisibility && (
        <ModalConfirmation
          open={!!showConsConfirmVisibility && !showVerifyModalVisibility}
          disableBackdropClick
          onClose={handleToggleConsConfirmModal}
          mainContent="Complete appointment?"
          subContent="Please note appointment details to create an invoice after completing"
          Icon={<ConfirmIcon />}
          otherActionsContent={() => (
            <>
              <CustomButton
                onClick={() => {
                  waitingRoomDispatcher.cancelConsult(
                    callId || appointmentData?.callId
                  );
                  handleToggleConsConfirmModal();
                  initHubConnection(accessToken);
                  setHideWaitingList(false);
                  waitingRoomDispatcher.setState(
                    'pendingConsultationData',
                    null
                  );
                }}
                variant="contained"
                className="red"
              >
                Cancel call
              </CustomButton>
              <CustomButton
                onClick={() => {
                  waitingRoomDispatcher.completeConsult(
                    callId || appointmentData?.callId
                  );
                  handleToggleConsConfirmModal();
                  initHubConnection(accessToken);
                  setHideWaitingList(false);
                  waitingRoomDispatcher.setState(
                    'pendingConsultationData',
                    null
                  );
                  // handleToggleModalInvoiceForm();
                }}
                variant="contained"
                color="primary"
              >
                Complete
              </CustomButton>
            </>
          )}
        />
      )}
      {waitingModalVisibility && (
        <ModalConfirmation
          open={!!waitingModalVisibility}
          onClose={() => {}}
          mainContent="Connecting"
          subContent="Please wait for the client to connect the call with you."
          isShowActions={false}
          Icon={<ConnectingIcon />}
        />
      )}
      {showModalCancel && (
        <ModalConfirmation
          open={!!showModalCancel}
          onClick={() => {
            rejoinCall(false);
            waitingRoomDispatcher.setState('rejoinCallData', null);
            handleToggleCancelModal();
          }}
          onClose={handleToggleCancelModal}
          mainContent="Cancel call"
          subContent="Are you sure you want to cancel this call?"
          Icon={<EndCall2Icon />}
          confirmLabel="Confirm"
          confirmColor="red"
        />
      )}
      {summaryModal && (
        <ModalSummary
          open={!!summaryModal}
          onClose={() => waitingRoomDispatcher.setState('summaryModal', false)}
          summaryData={summaryData}
          dataSunmmitted={dataSunmmitted}
          onSubmit={(data) => {
            waitingRoomDispatcher.updateSummarySoap(callId, data, () => {
              waitingRoomDispatcher.setState('summaryModal', false);
              waitingRoomDispatcher.setState('consConfirmVisibility', true);

              // handleEndCall();
            });
          }}
        />
      )}
      {showModalDisconnected && (
        <ModalConfirmation
          disableBackdropClick
          open={!!showModalDisconnected && rejoinCallData}
          mainContent="Disconnected call"
          subContent={
            <span>
              Your previous call with{' '}
              <strong>{rejoinCallData?.PatientFullName}</strong> has been
              disconnected.
            </span>
          }
          otherActionsContent={() => (
            <>
              <CustomButton
                onClick={handleToggleDisconnectedModal}
                variant="contained"
                color="primary"
                width={166}
                margin="0 16px"
              >
                Done
              </CustomButton>
            </>
          )}
        />
      )}
      {showModalLoadingSummary && (
        <ModalLoading
          open={!!showModalLoadingSummary}
          onClose={() => setShowModalLoadingSummary(false)}
          message="Please wait for a second"
        />
      )}
    </>
  );
};

export default WaitingRoom;
